import * as CONFIG from './stepConfiguration';
// import { COUNTRY } from '../../common/constants';

// If you update this, the ID should change!
export const DEFAULT_CONFIG = {
  id: 1,
  order: [CONFIG.Reason, CONFIG.Contact],
};

// Must start at 2 because the original default is 1
export const FUNNEL_CONFIGURATIONS = [
  // EXAMPLE CONFIGURATION FOR QUICK USE.
  // {
  //   id: 2,
  //   active: true,
  //   trafficSplit: 0.5,
  //   segment: {
  //     country: [COUNTRY.unitedStates],
  //     locality: ['toronto'],
  //   },
  //   order: [ ...ADD STEPS HERE ],
  // },
  // NOTES:
  // * 'trafficSplit' must be a value between 0 and 1. ie 0.5 = 50%
  // * If 'segment' is not provided, it will include users from everywhere
];
